export const initFlixxTeam = function (config) {
  if ($('.flixx_team.list').length > 0) {
    $('.flixx_team.list').each(function () {
      let el = this;
      let $infoBox = $('.info-box', this)
      let $infoBoxDetails = $('.info-box .details', this);
      let $infoBoxCloseButton = $('.info-box button', this);

      // Reset info box content to prepair it for next use.
      $infoBox.removeClass('visible');

      // Open info box and set position
      $('.person.has-details a.btn-secondary', this).on('click', function (e) {
        let elTop = parseInt($('.grid', el).offset().top);
        e.preventDefault();
        let $person = $(this).parents('.person');
        let $personDetails = $person.find('.person-details');
        $infoBox
          .addClass('visible')
          .css('top', (parseInt($person.offset().top) - elTop) + 'px')
          .css('min-height', (parseInt($person.height()) + 2) + 'px');
        $infoBoxDetails.html($personDetails.html());
      });

      // Click to close info box
      $infoBoxCloseButton.on('click', function () {
        $infoBox.removeClass('visible');
        $infoBoxDetails.empty();
      });

      // ESC key to close info box
      $(document).bind('keydown', function (e) {
        if ((e.which == 27) && ($infoBox.hasClass('visible'))) {
          console.log('Triggered ESC key. Close info box.');
          $infoBox.removeClass('visible');
        }
      });
    });
  }
}
